// extracted by mini-css-extract-plugin
export default {"intro":"ProjectIntro_intro__ZvJpW"};